import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import { googleMapsConfig } from './config.js';

let loadPromise = null;

/**
 * Loads the Google Maps libraries the picker needs and resolves with them.
 * Every caller shares the same in-flight promise, so the bootstrap script is injected once.
 *
 * @returns {Promise<{ Map: typeof google.maps.Map, AdvancedMarkerElement: typeof google.maps.marker.AdvancedMarkerElement, PlaceAutocompleteElement: typeof google.maps.places.PlaceAutocompleteElement }>}
 */
export function loadGoogleMaps() {
    if (loadPromise) {
        return loadPromise;
    }

    const { apiKey, language, region } = googleMapsConfig();

    if (!apiKey) {
        return Promise.reject(new Error('Google Maps API key is not configured.'));
    }

    setOptions({ key: apiKey, v: 'weekly', language, region });

    loadPromise = Promise.all([importLibrary('maps'), importLibrary('marker'), importLibrary('places')])
        .then(([{ Map }, { AdvancedMarkerElement }, { PlaceAutocompleteElement }]) => ({
            Map,
            AdvancedMarkerElement,
            PlaceAutocompleteElement,
        }))
        .catch((error) => {
            loadPromise = null;

            throw error;
        });

    return loadPromise;
}
